export function generateSnippet(url: string) {
  return `<iframe id="search-widget" src="${url}" frameborder="0"scrolling="no" width="100%"></iframe>
<script type="text/javascript" src="https://search-widget.auradevelop.com/host.js"></script>`;
}
